export const footer = {
tagline: 'Bienestar • Cuidado Personal • Venta Directa',
company: 'Empresa',
legal: 'Legal',
connect: 'Contacto',
rights: '© 2026 One More Global Inc. Todos los derechos reservados.',
address: '8556 Katy Freeway, Suite 120, Houston, TX 77024',
};
